<template>
  <Icon v-tooltip.bottom="'Click here to see help.'" type="favicon" icon="HelpBrowser" class="text-left cursor"
    @click="showHelpDialog" />
</template>

<script>
export default {
  props: ["header", "body"],
  methods: {
    showHelpDialog() {
      this.emitter.emit("open-dialog", {
        dialogType: "info",
        header: this.header,
        message: this.body,
      });
    },
  },
};
</script>
